import { render } from "./Criminal.vue?vue&type=template&id=834f3fc2&scoped=true"
import script from "./Criminal.vue?vue&type=script&lang=js"
export * from "./Criminal.vue?vue&type=script&lang=js"

import "./Criminal.vue?vue&type=style&index=0&id=834f3fc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-834f3fc2"]])

export default __exports__